import {
  componentName,
  OutboundAppButtonClass,
} from './OutboundAppButtonClass';
import '@descope-ui/descope-button';
import '@descope-ui/descope-icon';

customElements.define(componentName, OutboundAppButtonClass);

export { OutboundAppButtonClass, componentName };
